import { logger } from '@sendpayments/js-utils';
import dayjs from 'dayjs';

const getSecondsFrom = (originalDate) => {
  const inSeconds = dayjs().diff(originalDate, 'seconds');
  return inSeconds;
};

export const reduce = (state, action) => {
  const { payload } = action;
  const { key, data } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/SET_REMOTE_DATA. payload need to be passed`, action);
  }

  if (!key) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/SET_REMOTE_DATA. key need to be passed`, action);
  }

  const currentRemoteData = state[key];
  if (!currentRemoteData) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/SET_REMOTE_DATA. ${key} need to be initialized first.`,
      action,
    );
  }

  const prevState = state[key];

  if (!prevState) {
    return state;
  }

  logger.log('@sendpayments/react-shared/remote-data', `reducer/SET_REMOTE_DATA. ${key} set with.`, data);

  return {
    ...state,
    [key]: {
      loading: false,
      data,
      failed: false,
      initialized: true,
      invalidate: false,
      lastUpdated: +new Date(),
      fetching: false,
      offline: false,
      requestId: undefined,
      fetched: prevState.fetched ? prevState.fetched : true,
      requestStartDuration: undefined,
      requestDuration: prevState.requestStartDuration ? `${getSecondsFrom(prevState.requestStartDuration)} seconds` : undefined,
    },
  };
};
